import {GridBasis} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridBasis';
import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridCell, IGridHeaderCell} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import bind from 'bind-decorator';

export class FrameRowHeaderCell implements IGridHeaderCell
{
    private constructor(public readonly rowIndex:number | -1,
                        public readonly basis:GridBasis)
    {
    }

    getKind():GridCellKind
    {
        return GridCellKind.FrameRowHeader;
    }

    @bind
    getBasis():GridBasis
    {
        return this.basis;
    }

    @bind
    isEqualTo(other:IGridCell):boolean
    {
        return other &&
            other.getKind() === GridCellKind.FrameRowHeader &&
            (other as FrameRowHeaderCell).rowIndex === this.rowIndex;
    }

    toString():string
    {
        return `${this.rowIndex}`;
    }

    public static forRow(rowIndex:number):FrameRowHeaderCell
    {
        return new FrameRowHeaderCell(rowIndex, GridBasis.stretch(1));
    }
}
